import React from "react";
import Icons from "../../icons";
const BottomMenu = (props) => {
    return (
        <React.Fragment>
            <div className="sortMobileTransition">
                <div className="transparentOverlay" onClick={() => props.showBottomMenu(false)}></div>
                <div className="sortMobile animated faster fadeInUpx2 medium">
                    <div className="alignMiddle rowSpaceBetween sortHead">
                        <h1>Sort by</h1>
                        <span onClick={() => props.showBottomMenu(false)}><Icons name="close" className="icon" /></span>
                    </div>
                    <ul>
                        {props.sortOptions && props.sortOptions.map((item, index) => {

                            return <li key={index} className={props.selectedSortBy === item.sortBy&& props.isSortDesc == item.isSortDesc ? "alignMiddle rowSpaceBetween active":"alignMiddle rowSpaceBetween"} onClick={() => props.onSortByClick(item.sortBy, item.isSortDesc)}>
                                <div className="">{item.label}</div>
                                <div className="">
                                    {props.selectedSortBy === item.sortBy && props.isSortDesc == item.isSortDesc ? <span className="badges profileChecked sortChecked green"></span> : null}
                                    <span><Icons name={item.iconName} className="icon" /></span>
                                </div>
                            </li>
                        })
                        }
                    </ul>
                </div>
            </div>
        </React.Fragment>
    );
};

export default BottomMenu;
